export function apiUserStatusList(token,callback){
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token':token }
    fetch(global.rxu.get(global.rxu.config, 'api_user_status')+'?page=0&size=50' , {
        method: 'GET',
        body: null,
        headers: headers 
    })
    .then((res) => { return res.json() })
    .then((json) => {
        callback(json)
    }).catch(er => console.log(er))
}

export function apiGetUserStatus(token, userid, callback ){
    if (userid) {
        let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token': token }
        fetch(global.rxu.get(global.rxu.config, 'api_get_user_status') + userid, {
            method: 'GET',
            body: null,
            headers: headers 
        })
        .then((res) => { return res.json() })
        .then((json) => {
            callback(json)
        }).catch(er => console.log(er))
    }
    
}

export function apiUpdateStatus(token,params,callback){
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token': token }
    fetch(global.rxu.get(global.rxu.config, 'api_update_status'), {
        method: 'POST',
        body: JSON.stringify(params),
        headers: headers 
    })
    .then((res) => { return res.json() })
    .then((json) => {
        callback(json)
    }).catch(er => console.log(er))
}